import { MaskService } from 'react-native-masked-text';

export const states = [
  { value: 'AC', label: 'AC' },
  { value: 'AL', label: 'AL' },
  { value: 'AP', label: 'AP' },
  { value: 'AM', label: 'AM' },
  { value: 'BA', label: 'BA' },
  { value: 'CE', label: 'CE' },
  { value: 'DF', label: 'DF' },
  { value: 'ES', label: 'ES' },
  { value: 'GO', label: 'GO' },
  { value: 'MA', label: 'MA' },
  { value: 'MT', label: 'MT' },
  { value: 'MS', label: 'MS' },
  { value: 'MG', label: 'MG' },
  { value: 'PA', label: 'PA' },
  { value: 'PB', label: 'PB' },
  { value: 'PR', label: 'PR' },
  { value: 'PE', label: 'PE' },
  { value: 'PI', label: 'PI' },
  { value: 'RJ', label: 'RJ' },
  { value: 'RN', label: 'RN' },
  { value: 'RS', label: 'RS' },
  { value: 'RO', label: 'RO' },
  { value: 'RR', label: 'RR' },
  { value: 'SC', label: 'SC' },
  { value: 'SP', label: 'SP' },
  { value: 'SE', label: 'SE' },
  { value: 'TO', label: 'TO' },
];

export const checkIfHasLastname = (name: string) => {
  const completedName = name.trim().split(' ');

  return completedName.length > 1;
};

export const hasOnlyLetters = (str: string): boolean => {
  return new RegExp('^[A-Za-zÀ-ÖØ-öø-ÿ]+$').test(removeWhitespaces(str));
};

export const removeWhitespaces = (str: string | undefined | null): string => {
  return str?.replace(/\s/g, '') ?? '';
};

export const cpfIsValid = (cpf: string): boolean => {
  return MaskService.isValid('cpf', cpf);
};

export const validateCellphone = (rawNumber: string): boolean => {
  if (rawNumber.length === 15 && rawNumber.slice(5, 6) === '9') {
    return MaskService.isValid('cel-phone', rawNumber);
  }
  return false;
};

export const getRawDocument = (document: string): string => {
  return document.split('.').join('').split('-').join('').split('/').join('');
};

export const getRawZipcode = (document: string): string => {
  return document.split('-').join('');
};

export const getRawCellphone = (document: string): string => {
  return document.replace(/[^0-9]+/g, '');
};

export const stringToCapitalCase = (
  str: string | undefined
): string | undefined => {
  return str?.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};

export const getPhoneInfos = (cellphone: string) => {
  const formattedCellphone = getRawCellphone(cellphone);

  return {
    ddd: formattedCellphone.substring(0, 2),
    phone: formattedCellphone.substring(2),
  };
};

export const getCompleteAddress = (address: DefaultForm.Address) => {
  return `${address.zipcode} ${address.street} ${address.complement} ${address.number} ${address.neighborhood} ${address.city} ${address.state}`
    .trim()
    .replace('  ', ' ');
};

export function getEndCardNumber(cardNumber?: string) {
  if (cardNumber) return cardNumber.slice(-4);

  return 'Indisponível';
}

export function formatCurrency(value: number) {
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value as number);
  return formattedValue.toString().replace('R$', '').trim();
}
